import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../../../ui/Atoms/Button';

import { scrollToTop } from './scrollToTop';

import * as S from './DownloadSection.style';

export const DownloadSection = ({
  title,
  dataTrackAttribute,
  description,
  buttonLabel,
  resourceUrl,
  isFormRequired,
}) => {
  if (!title || !description || !buttonLabel) {
    return null;
  }

  const hasButton = resourceUrl && !isFormRequired;

  return (
    <S.DownloadSection>
      <S.Title>{title}</S.Title>
      <S.Description>{description}</S.Description>
      {hasButton && (
        <Button
          dataTrackAttribute={dataTrackAttribute}
          link={resourceUrl}
          target='_blank'
        >
          {buttonLabel}
        </Button>
      )}
      {isFormRequired && (
        <Button onClick={() => scrollToTop()}>{buttonLabel}</Button>
      )}
    </S.DownloadSection>
  );
};

DownloadSection.propTypes = {
  /**
   * Label of the button.
   */
  buttonLabel: PropTypes.string.isRequired,
  /**
   * DataTrack attribute
   */
  dataTrackAttribute: PropTypes.string,
  /**
   * Description of the download section.
   */
  description: PropTypes.string.isRequired,
  /**
   * Allow user to directly download the media from the download section
   * if isFormRequired = true AND if there is a resourceUrl.
   */
  isFormRequired: PropTypes.bool,
  /**
   * Url of the media.
   */
  resourceUrl: PropTypes.string,
  /**
   * Title of the download section.
   */
  title: PropTypes.string.isRequired,
};

export default DownloadSection;
